import React from 'react';
import PropTypes from 'prop-types';

export const Button = (props) => {

const style = {
	backgroundColor: `${ props.color }`,
	color: `${ props.textColor }`
}

	return (
		props.link ?
			<a className="btn btn--cta-kiwi btn-basic" href={props.link} style={ style } target="_blank">
				<span>{props.label}</span>
			</a>
			:
			<button className="btn btn--cta-kiwi btn-basic" style={ style }>
				<span>{props.label}</span>
			</button>
	)
};


Button.propTypes = {
	label: PropTypes.string,
	link: PropTypes.string,
	color: PropTypes.string,
	textColor: PropTypes.string
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Button.js